import { LinesActionsTypes } from "../types/Lines.reducer.types";

export function listLinesRequest(filter, { isAdmin = false }) {
  return {
    type: LinesActionsTypes.LIST_REQUEST,
    payload: { filter, isAdmin }
  };
}
